<template>
  <div class="worth-container">
    <img src="https://ysh-cdn.kaidicloud.com/test/appshare/bg_download_9.png" />
    <img src="https://ysh-cdn.kaidicloud.com/test/appshare/bg_download_13.png" />
    <img src="https://ysh-cdn.kaidicloud.com/test/appshare/bg_download_11.png" />
    <img src="https://ysh-cdn.kaidicloud.com/test/appshare/bg_download_12.png" />

    <div class="botttom-button">
      <img class="btn" id="download" src="https://ysh-cdn.kaidicloud.com/test/appshare/ic_download_btn.png" catch:tap="goMemberSettlement" />
      <img class="btn-bg" src="https://ysh-cdn.kaidicloud.com/test/appshare/bg_download_8.png" catch:tap="goMemberSettlement" />
    </div>
  </div>
</template>

<script>
import { getAppVersionConfig } from '@/api/data'

export default {
  data() {
    return {
      downloadUrl: '',
      query: '',
      appQuery: '',
      code: ''
    }
  },
  created() {},
  mounted() {
    let { path = '', ...res } = this.$route.query || {}

    //console.log(this.$route.query.code)
    //对接ulink
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://g.alicdn.com/jssdk/u-link/index.min.js";
    document.getElementsByTagName("head")[0].appendChild(script);
       //等待挂载完成
   script.onload = function () {
    const ULink =window.ULink
    const url = (window.location.href ||'').split('?')[1]
    const data = ULink.getUriParams(url)
    // const ULinkId=process.env.VUE_APP_BUILD_ENV=="pro"?"usr172adk0jspr32":"usr14vktt1f572q3"
    const ULinkId=process.env.VUE_APP_BUILD_ENV=="pro"?"usr172adk0jspr32":"usr14vktt1f572q3"
    ULink([{
      id: ULinkId,
      data: {
        iCode:data.iCode||""
      },
      selector: "#download",
   }])
  }


    for (const [key, value] of Object.entries(res)) {
      this.query = key + '=' + value + '&' + this.query
    }

    if (this.query) {
      this.appQuery = path + '?' + this.query.substring(0, this.query.lastIndexOf('&'))
    } else {
      this.appQuery = path
    }

    if (this.isEvn() == 'Android') {
      this.appQuery = 'yshapp://ysh:8888/' + this.appQuery
    }

    //  IOS  + this.appQuery
    // else {
    //   this.appQuery = 'h.kaidicloud.com/' + this.appQuery
    // }

    this.fetchData()
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.worth-container {
  display: flex;
  flex-direction: column;
}

.worth-container img {
  width: 100vw;
  height: auto;
}

.botttom-button {
  width: 100vw;
  height: 150px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
}

.botttom-button .btn {
  position: absolute;
  left: 50%;
  top: 8px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
}

.botttom-button .btn-bg {
  width: 100%;
  height: 150px;
}
</style>
